export const VERIFICATION_STATE = {
  IN_PROGRESS: 'VERIFICATION_IN_PROGRESS',
  SUCCESS: 'VERIFICATION_SUCCESS',
  FAIL: 'VERIFICATION_FAIL',
  PREPROCESS_FAIL: 'VERIFICATION_PREPROCESS_FAIL'
};

export const STEPS_LABELS = {
  UPLOAD: 'UPLOAD',
  MAP: 'MAP',
  PREVIEW: 'PREVIEW',
  RUN: 'RUN',
  REVIEW: 'REVIEW',
};

export const STEPS = {};
STEPS[STEPS_LABELS.UPLOAD] = {
  page: 1,
  label: 'Upload',
  url: '',
  status: 'uploading'
};
STEPS[STEPS_LABELS.MAP] = {
  page: 2,
  label: 'Map',
  url: 'map',
  status: 'mapping_files'
};
STEPS[STEPS_LABELS.PREVIEW] = {
  page: 3,
  label: 'Preview',
  url: 'preview',
  status: 'previewing'
};
STEPS[STEPS_LABELS.RUN] = {
  page: 4,
  label: 'Run',
  url: 'run',
  status: 'run'
};
STEPS[STEPS_LABELS.REVIEW] = {
  page: 5,
  label: 'Review',
  url: 'review',
  status: 'complete'
};

export const ALL_STEPS = Object.values(STEPS);
export const ALL_STEPS_LABELS = Object.values(STEPS_LABELS);
